import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { Injections } from '../../services/injections';
import type { StoreModel } from '../..';
import type { FedexHubId, ZoneApplyPreviewRequest, ZonePreviewResponse } from '../../services/CarrierService/types';
import type { ZipZoneUploadData } from '../../../pages/AdminPages/ZipZoneMappings/ZipZoneUpload';

export interface CarrierAssetModel {
  carrierActionStart: Action<CarrierAssetModel, void>;
  lastAction?: number;
  getFedexHudIds: Thunk<CarrierAssetModel, void, Injections, StoreModel, Promise<FedexHubId>>;
  setFedexHubIds: Action<CarrierAssetModel, FedexHubId[]>;
  fedexHubIds: FedexHubId[];
  previewZipZones: Thunk<CarrierAssetModel, ZipZoneUploadData, Injections, StoreModel, Promise<ZonePreviewResponse>>;
  applyZipZonePreview: Thunk<
    CarrierAssetModel,
    ZoneApplyPreviewRequest,
    Injections,
    StoreModel,
    Promise<ZonePreviewResponse>
  >;
}
export const carrierAssetModel: CarrierAssetModel = {
  carrierActionStart: action((state, payload) => {
    state.lastAction = Date.now();
  }),
  getFedexHudIds: thunk(async (actions, payload, { getStoreState, injections }) => {
    try {
      actions.carrierActionStart();
      const res = await injections.carrierService.getFedexHubIds();
      actions.setFedexHubIds(res);
      return res;
    } catch (error) {
      return error;
    }
  }),
  setFedexHubIds: action((state, payload) => {
    state.fedexHubIds = payload;
  }),
  fedexHubIds: [],
  previewZipZones: thunk(async (actions, payload, { getStoreState, injections }) => {
    try {
      actions.carrierActionStart();
      return await injections.carrierService.previewZipZones(payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }),
  applyZipZonePreview: thunk(async (actions, payload, { getStoreState, injections }) => {
    try {
      actions.carrierActionStart();
      return await injections.carrierService.applyZipZonePreview(payload);
    } catch (error) {
      console.log(error);
      throw error;
    }
  }),
};
